import { render } from "./Popup.vue?vue&type=template&id=0b6ef97a&scoped=true"
import script from "./Popup.vue?vue&type=script&lang=js"
export * from "./Popup.vue?vue&type=script&lang=js"

import "./Popup.vue?vue&type=style&index=0&id=0b6ef97a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0b6ef97a"

export default script